stripe-card-element-modal {
  display: block;
}
